import { useDispatch, useSelector } from 'react-redux';
import { resetSwitchClinicState } from 'Redux/modules/webChat/consult/actions';

const useSwitchClinicState = () => {
  const dispatch = useDispatch();

  const {
    status,
    error,
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
  } = useSelector(state => state.webChat.consults);
  const isLoading = status?.switchConsultToOtherClinic === 0;
  const switchError = error?.switchConsultToOtherClinic;

  const resetState = () => {
    dispatch(resetSwitchClinicState());
  };

  return {
    isLoading,
    error: switchError,
    resetState,
  };
};

export default useSwitchClinicState;
